export const mockData = {
  businessAreas: [
    {
      id: 1,
      title: "Mining",
      description: "With vast reserves of copper, cobalt, gold and other valuable minerals, the mining industry offers highly profitable investment opportunities. Our team will guide you through the complex regulatory landscape, forge strategic alliances, and promote environmentally sustainable mining practices.",
      image: "https://images.unsplash.com/photo-1689489608113-107f10b63d5e?w=800&q=80",
      icon: "Pickaxe"
    },
    {
      id: 2,
      title: "Agriculture",
      description: "The DRC's fertile land and favorable climate make it an ideal destination for agricultural investments. From large-scale farming to agro-processing, we can connect you with local partners and provide support in areas such as land acquisition, logistics, and market access.",
      image: "https://images.unsplash.com/photo-1700743625236-23f6121862e3?w=800&q=80",
      icon: "Sprout"
    },
    {
      id: 3,
      title: "Infrastructure",
      description: "Be part of this transformative journey by investing in road networks, ports, railways, and energy infrastructure. Our team will assist you in identifying viable projects, securing financing, and navigating the regulatory landscape.",
      image: "https://customer-assets.emergentagent.com/job_fb5b119e-cc0c-4fbb-b433-83505048e85c/artifacts/726d6viz_vlcsnap-2023-10-24-21h37m43s665.png",
      icon: "Building2"
    },
    {
      id: 4,
      title: "Renewable Energy",
      description: "Embrace the future of energy by investing in renewable sources in the DRC. With abundant hydro, solar, and wind resources, the country has immense potential for clean energy generation.",
      image: "https://images.unsplash.com/photo-1630770131048-375099b304ed?w=800&q=80",
      icon: "Zap"
    },
    {
      id: 5,
      title: "Telecommunications",
      description: "The DRC's telecommunications sector is experiencing rapid growth, driven by increasing mobile penetration and demand for digital services. Invest in this thriving sector and capitalize on the country's growing connectivity needs.",
      image: "https://images.unsplash.com/photo-1700463108455-956c595bc97b?w=800&q=80",
      icon: "Radio"
    }
  ],

  videos: {
    english: "https://customer-assets.emergentagent.com/job_fb5b119e-cc0c-4fbb-b433-83505048e85c/artifacts/sll1yze6_ol-consult-english.mp4",
    french: "https://customer-assets.emergentagent.com/job_fb5b119e-cc0c-4fbb-b433-83505048e85c/artifacts/wudqqfju_ol-consult-copy-french%20%281%29.mp4"
  },

  drcImages: {
    ceo: "https://customer-assets.emergentagent.com/job_global-consulting-2/artifacts/9tivlgt2_Olivier%20Shekinah%20.jpeg",
    city1: "https://customer-assets.emergentagent.com/job_fb5b119e-cc0c-4fbb-b433-83505048e85c/artifacts/9o2sppn4_vlcsnap-2023-10-24-21h41m01s562.png",
    city2: "https://customer-assets.emergentagent.com/job_fb5b119e-cc0c-4fbb-b433-83505048e85c/artifacts/drvug5d6_vlcsnap-2023-11-10-01h37m01s077.png",
    infrastructure: "https://customer-assets.emergentagent.com/job_fb5b119e-cc0c-4fbb-b433-83505048e85c/artifacts/726d6viz_vlcsnap-2023-10-24-21h37m43s665.png"
  },

  marketData: {
    minerals: [
      { name: 'Cobalt', country: 'DRC', price: 32450, unit: 'USD/MT', change: 2.5 },
      { name: 'Copper', country: 'DRC', price: 8657, unit: 'USD/MT', change: -0.8 },
      { name: 'Gold', country: 'DRC', price: 2034, unit: 'USD/OZ', change: 1.2 },
      { name: 'Diamonds', country: 'DRC', price: 156, unit: 'USD/CT', change: 0.5 },
      { name: 'Coltan', country: 'DRC', price: 245, unit: 'USD/KG', change: 3.1 },
      { name: 'Zinc', country: 'DRC', price: 2567, unit: 'USD/MT', change: -1.2 },
      { name: 'Manganese', country: 'DRC', price: 1834, unit: 'USD/MT', change: 0.9 },
      { name: 'Oil', country: 'Congo Brazzaville', price: 82.45, unit: 'USD/BBL', change: 1.8 },
      { name: 'Oil', country: 'Angola', price: 81.95, unit: 'USD/BBL', change: 1.7 },
    ],
    economicIndicators: [
      { name: 'GDP Growth', country: 'DRC', value: 6.2, unit: '%', change: 0.3 },
      { name: 'Inflation', country: 'DRC', value: 8.5, unit: '%', change: -0.5 },
      { name: 'USD/CDF', country: 'DRC', value: 2450, unit: '', change: 0.2 },
      { name: 'GDP Growth', country: 'Congo Brazzaville', value: 3.8, unit: '%', change: 0.1 },
      { name: 'Inflation', country: 'Congo Brazzaville', value: 4.2, unit: '%', change: -0.3 },
      { name: 'USD/XAF', country: 'Congo Brazzaville', value: 620, unit: '', change: 0.1 },
      { name: 'GDP Growth', country: 'Angola', value: 4.5, unit: '%', change: 0.4 },
      { name: 'Inflation', country: 'Angola', value: 12.3, unit: '%', change: -0.8 },
      { name: 'USD/AOA', country: 'Angola', value: 835, unit: '', change: 0.3 },
    ]
  },

  // Market data for ticker - Real-time commodity prices & economic indicators
  marketData: {
    minerals: [
      { name: 'Cobalt', country: 'DRC', price: 32450, unit: 'USD/MT', change: 2.5 },
      { name: 'Copper', country: 'DRC', price: 8657, unit: 'USD/MT', change: -0.8 },
      { name: 'Gold', country: 'DRC', price: 2034, unit: 'USD/OZ', change: 1.2 },
      { name: 'Diamonds', country: 'DRC', price: 156, unit: 'USD/CT', change: 0.5 },
      { name: 'Coltan', country: 'DRC', price: 245, unit: 'USD/KG', change: 3.1 },
      { name: 'Zinc', country: 'DRC', price: 2567, unit: 'USD/MT', change: -1.2 },
      { name: 'Manganese', country: 'DRC', price: 1834, unit: 'USD/MT', change: 0.9 },
      { name: 'Oil', country: 'Congo Brazzaville', price: 82.45, unit: 'USD/BBL', change: 1.8 },
      { name: 'Oil', country: 'Angola', price: 81.95, unit: 'USD/BBL', change: 1.7 },
    ],
    economicIndicators: [
      { name: 'GDP Growth', country: 'DRC', value: 6.2, unit: '%', change: 0.3 },
      { name: 'Inflation', country: 'DRC', value: 8.5, unit: '%', change: -0.5 },
      { name: 'USD/CDF', country: 'DRC', value: 2450, unit: '', change: 0.2 },
      { name: 'GDP Growth', country: 'Congo Brazzaville', value: 3.8, unit: '%', change: 0.1 },
      { name: 'Inflation', country: 'Congo Brazzaville', value: 4.2, unit: '%', change: -0.3 },
      { name: 'USD/XAF', country: 'Congo Brazzaville', value: 620, unit: '', change: 0.1 },
      { name: 'GDP Growth', country: 'Angola', value: 4.5, unit: '%', change: 0.4 },
      { name: 'Inflation', country: 'Angola', value: 12.3, unit: '%', change: -0.8 },
      { name: 'USD/AOA', country: 'Angola', value: 835, unit: '', change: 0.3 },
    ]
  },

  statistics: [
    {
      value: "70%",
      label: "Global Cobalt Reserves",
      description: "DRC holds the majority of world's cobalt"
    },
    {
      value: "100 GW",
      label: "Hydroelectric Potential",
      description: "Untapped renewable energy capacity"
    },
    {
      value: "80M",
      label: "Hectares Arable Land",
      description: "Vast agricultural opportunities"
    },
    {
      value: "90M+",
      label: "Population",
      description: "Growing consumer market"
    }
  ],

  testimonials: [
    {
      id: 1,
      quote: "Success is not the destination, but the journey we embrace. Persistence and vision chart the path, regardless of the venture.",
      author: "Business Leader"
    },
    {
      id: 2,
      quote: "Work is a fine thing when it does not take too much of your spare time.",
      author: "Industry Expert"
    },
    {
      id: 3,
      quote: "The best time to invest in Africa was 10 years ago. The second best time is now.",
      author: "Investment Advisor"
    }
  ],

  blogPosts: [
    {
      id: 0,
      title: "Chekinah Olivier : « Comment Sécuriser Les Investissements dans le Secteur Minier Africain »",
      excerpt: "Avec un projet de cartographie des ressources minières, l'homme d'affaires Chekinah Olivier souhaite aider les entreprises souhaitant se lancer dans le secteur minier à sécuriser leurs investissements.",
      author: "Forbes Afrique - BrandVoice",
      date: "October 2024",
      readTime: "6 min",
      image: "https://forbesafrique.com/wp-content/uploads/2024/10/Chekinah-Olivier-BrandVoice-%C2%A9OL-Consult-SARL-Oct.2024_Exclu-Web-_Forbesafrique.com_.jpg",
      category: "Mining",
      featured: true,
      externalLink: "https://forbesafrique.com/chekinah-olivier-comment-securiser-les-investissements-dans-le-secteur-minier-africain/"
    },
    {
      id: 1,
      title: "Closing of works of the minerals of the future forum in Riyadh, Saudi Arabia",
      excerpt: "The Minister of Mines, Antoinette N'Samba Kalambayi, in accordance with the vision of the Head of State Félix-Antoine Tshisekedi and as part of the mission, continues to exploit and promote the potential abounding in the DRC mining sector, led to Riyadh, Saudi Arabia, a large delegation made up of various heads of specialized services in the said sector to participate in the forum on the minerals of the future.",
      author: "Lysette NGALULA",
      date: "January 2024",
      readTime: "12 min",
      image: "https://images.unsplash.com/photo-1689489608113-107f10b63d5e?w=600&q=80"
    },
    {
      id: 2,
      title: "The new Kinshasa financial center, a product of Turkish-Congolese cooperation",
      excerpt: "The new Kinshasa financial center, a product of Turkish-Congolese cooperation, was inaugurated by Congolese President Félix Tshisekedi ahead of the presidential elections, with construction commencing in November 2022.",
      author: "Lysette NGALULA",
      date: "December 2023",
      readTime: "12 min",
      image: "https://images.unsplash.com/photo-1691149210746-c6bbb40f4bf6?w=600&q=80"
    },
    {
      id: 3,
      title: "DRC's Telecommunications Boom: 5G and Digital Transformation",
      excerpt: "The Democratic Republic of Congo is experiencing a telecommunications revolution. With increasing mobile penetration and demand for digital services, the sector offers unprecedented investment opportunities.",
      author: "Tech Analyst",
      date: "February 2024",
      readTime: "8 min",
      image: "https://images.unsplash.com/photo-1700463108455-956c595bc97b?w=600&q=80"
    }
  ],

  services: [
    {
      id: 1,
      title: "Company Formation",
      description: "Complete guide to forming your company in DRC with full legal support and documentation assistance.",
      icon: "Building"
    },
    {
      id: 2,
      title: "Legal Protection",
      description: "Guarantees and protection for your investments with comprehensive legal frameworks.",
      icon: "Shield"
    },
    {
      id: 3,
      title: "Business Consulting",
      description: "Professional expertise for your success in navigating DRC's business landscape.",
      icon: "Briefcase"
    },
    {
      id: 4,
      title: "Market Entry Strategy",
      description: "Strategic planning and execution for successful market entry and expansion.",
      icon: "Target"
    }
  ],

  companyInfo: {
    name: "OL-CONSULT SARL",
    ceo: "CHEKINAH OLIVIER",
    ceoTitle: "Founder & CEO",
    tagline: "Invest with Confidence, Consult with Excellence",
    description: "For entrepreneurs and business owners, launching a successful venture is often difficult. With all of the ever-changing dynamics of the market, you need to stay on top of your game to get an edge over competitors. That's why quality professional consulting services are essential to ensure success in any business endeavor. Our team provides tailored solutions that help organizations pursue their goals and catapult beyond their competition. We offer specialized support with extensive knowledge in marketing strategy, financial planning, product development and management services—all designed to set up our clients for long-term success.",
    mission: "As your DRC trusted partner, we help you understand the Congolese business culture and establish strategic relationships with the government.",
    logo: "https://customer-assets.emergentagent.com/job_fb5b119e-cc0c-4fbb-b433-83505048e85c/artifacts/5uagf18m_WhatsApp%20Image%202023-10-18%20at%2012.25.45%20PM.jpeg",
    contact: {
      phone: "+243 832590522",
      email: "contact@ol-consult.com",
      address: "8314 Boulevard Du 30 Juin, Gombe, Kinshasa, République démocratique du Congo"
    },
    location: {
      address: "8314 Boulevard Du 30 Juin, Gombe, Kinshasa, République démocratique du Congo",
      coordinates: { lat: -4.3126, lng: 15.3156 } // Gombe, Kinshasa coordinates
    }
  },

  heroImage: "https://images.pexels.com/photos/9487241/pexels-photo-9487241.jpeg?w=1200&q=80"
};
